import { z } from "zod";

export const BrandTypographySchema = z.object({
  name: z.string().nullish(),
  family: z.string().nullish(),
  preview: z.string().nullish(),
  weights: z.array(z.number()).nullish(),
});

export const BrandColorSchema = z.object({
  hex: z.string().nullish(),
  name: z.string().nullish(),
});

export const BrandAssetSchema = z.object({
  id: z.string().nullish(),
  url: z.string().nullish(),
  alt: z.string().nullish(),
  category: z.enum(["logo", "product", "lifestyle", "other"]).nullish(),
});

export const BrandVoiceSchema = z.object({
  tone: z.string().nullish(),
  personality: z.array(z.string()).nullish(),
  key_phrases: z.array(z.string()).nullish(),
  messaging_guidelines: z.string().nullish(),
});

export const BrandDNASchema = z.object({
  brand_voice: BrandVoiceSchema.nullish(),
  colors: BrandColorSchema.array().nullish(),
  visual_layout_standards: z.string().nullish(),
  typography: BrandTypographySchema.array().nullish(),
});

export type BrandColor = z.infer<typeof BrandColorSchema>;
export type BrandTypography = z.infer<typeof BrandTypographySchema>;
export type BrandVoice = z.infer<typeof BrandVoiceSchema>;
export type BrandDNA = z.infer<typeof BrandDNASchema>;
